import { render, staticRenderFns } from "./MoonPhaseChartTemp.vue?vue&type=template&id=ff1c0fb6"
import script from "./MoonPhaseChartTemp.vue?vue&type=script&lang=js"
export * from "./MoonPhaseChartTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports